module.exports = __webpack_public_path__ + "static/media/ShipMt.f95f31ed.svg";